<div class="aems-card m-b-12">
  <div class="pure-g">
    <div class="pure-u-md-24-24 p-b-16">
      <h3>Workorder bulk actions</h3>
    </div>
  </div>

  <div class="m-b-36" style="display: flex; flex-direction: column; gap: 12px">
    <app-aems-multiline-tag-input
      [heightInPixels]="200"
      ngDefaultControl
      [(ngModel)]="workOrderNumbers"
      placeholder="Paste workorder numbers in any format or enter it manually and press enter"
      [regex]="regexConstants.WORK_ORDER_NUMBER"></app-aems-multiline-tag-input>
    <mc-input ngDefaultControl [(ngModel)]="deleteRemarkText" hiddenlabel placeholder="Remarks if any"></mc-input>
  </div>

  <!-- Buttons Section -->
  <div style="display: flex; gap: 16px">
    @if (authPolicies.isAppSupportAdmin) {
      <app-button-with-confirmation
        label="Retrigger Workorders for PO"
        appearance="primary"
        variant="filled"
        [hiddenlabel]="false"
        modalBody="Are you sure you want to retrigger the work orders?"
        modalHeading="Retrigger Work Orders"
        confirmButtonLabel="Yes, retrigger"
        cancelButtonLabel="No"
        [onConfirm]="onRetriggerClicked()"
        [disabled]="workOrderNumbers.length === 0">
      </app-button-with-confirmation>
    }
    <app-button-with-confirmation
      label="Retrigger STAR/SWAT Workorders"
      appearance="primary"
      variant="filled"
      [hiddenlabel]="false"
      modalBody="Are you sure you want to retrigger the STAR/SWAT work orders?"
      modalHeading="Retrigger STAR/SWAT Work Orders"
      confirmButtonLabel="Yes, retrigger"
      cancelButtonLabel="No"
      [onConfirm]="onRetriggerStarSwatClicked()"
      [disabled]="workOrderNumbers.length === 0">
    </app-button-with-confirmation>
    @if (authPolicies.isAppSupportAdmin) {
      <app-button-with-confirmation
        label="Delete Workorders"
        appearance="secondary"
        variant="filled"
        [hiddenlabel]="false"
        modalBody="Are you sure you want to DELETE the work orders?"
        modalHeading="Delete Work Orders"
        confirmButtonLabel="Yes, Delete"
        cancelButtonLabel="No"
        [onConfirm]="onDeleteClicked()"
        [disabled]="workOrderNumbers.length === 0 || deleteRemarkText === ''">
      </app-button-with-confirmation>
    }
  </div>
  <div class="m-t-16"></div>

  <!-- Result Section -->
  @if (retiggerResult.length > 0) {
    <div>
      <div style="margin-bottom: 3px">Retrigger status</div>
      <div class="work-orders-list aems-card" style="padding: 8px">
        <ul>
          @for (item of retiggerResult; track $index) {
            <li>
              <span>{{ item.workOrderId }}:</span><span class="m-l-4 mds-text--small-bold">{{ item.status }}</span>
            </li>
          }
        </ul>
      </div>
    </div>
  }
</div>
